import { useState } from "react";
import * as Styled from "./styles1";
import { functionService } from "../../lib/functions";
import { useNavigate } from "react-router-dom";
const SendOtp = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();

  const handleChange = (element, index) => {
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if (element.value && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };
  const isMailVerified = async () => {
    try {
        const email = localStorage.getItem("userEmail")
        const result = otp.join('');
        let response = await functionService.verifyOtp({code:result,email:email});
        if (response.response.data.data[0].is_code_valid == 'true') { 
            navigate('/company-table');
        }
    } catch (err) {
        console.log(err.message);
    }
}


  const handleSubmit = () => {
    isMailVerified();
  };

  return (
    <>
      <Styled.MainDiv>
        <div className="left_container">
          <div>
            <div className="head1">Enter the 4-digit OTP</div>
            <div className="otp_container">
              {otp.map((value, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={value}
                  onChange={(e) => handleChange(e.target, index)}
                  className="otp_input"
                />
              ))}
            </div>
            <button onClick={handleSubmit}>Submit OTP</button>
          </div>
        </div>
        <div className="right_container">
          <div></div>
        </div>
      </Styled.MainDiv>
    </>
  );
};

export default SendOtp;


